<template>
  <div
    class="flex flex-wrap align-center"
    data-qa="purchasing-item-actions-toolbar">
    <InDevelopmentInfo
      v-if="showActions.addСomment"
      :condition="CHAT_IN_DEVELOPMENT"
      prevent>
      <template #activator>
        <CommentDialog
          dialogue-type="ROW"
          :element.sync="elements[0]"
          :join-chat="options.joinChat"
          :user="options.user"
          @callback="options.callback"/>
      </template>
    </InDevelopmentInfo>
    <sPopover
      v-if="showActions.menu"
      placement="right-start"
      popper-class="menu"
      trigger="click"
      type="white">
      <div
        slot="reference">
        <sButton
          color="var(--white-color)"
          icon="menu"
          icon-size="18px"
          small
          type="text"/>
      </div>
      <div>
        <ChangeDate
          :elements.sync="elements"
          @callback="options.callback"/>
        <ChangeQuantity
          :elements.sync="elements"
          not_change
          @callback="options.callback"/>
      </div>
    </sPopover>
  </div>
</template>
<script>
import ChangeDate from 'components/purchasing/purch item/ChangeDate.vue'
import ChangeQuantity from 'components/common/dialogs/ChangeQuantity.vue'
import CommentDialog from 'components/purchasing/purch item/CommentDialog.vue'
import InDevelopmentInfo from 'components/common/elements/InDevelopmentInfo.vue'

import ApplicationApi from '@/api/applicationApi'
import { applicationMixin, filterSortMixin } from 'mixins'
const api = new ApplicationApi()

export default {
  name: 'purchasingItemActionsToolbar',
  mixins: [filterSortMixin, applicationMixin],
  data() {
    return {
      CHAT_IN_DEVELOPMENT: true,
      loading: false
    }
  },
  props: {
    options: Object,
    reject_condition: Boolean,
  },
  computed: {
    showActions() {
      const result = {
        addСomment: this.elements?.length == 1 && this.options.elements.length == 1,
        menu: this.elements?.length == 1 && this.options.elements.length == 1 && this.options.yourTurn,
        toolbar: false,
      }

      result.toolbar = !!Object.values(result)?.filter(i => i)?.length
      this.$emit('showActions', result)
      return result
    },
    elements() {
      let elems = this.options.elements || []
      this.$emit('update:reject_condition', !!elems && elems.length > 1 )
      return elems
    },
    first() {
      return this.elements[0] || {}
    },
  },
  methods: {
    async agree(decision, comm) {
      this.loading = true
      await api.agreeApplicationRows(this.options.item.id, this.elements.map(el => el.id), decision, comm)
        .then(res => {
          this.$root.$emit('updateHisory', res.data.agreeApplicationRows.event, true)
          this.elements.forEach(el => {
            let status = el.applicationRowStatuses.find(it => it.userId.trim() == this.options.user.id.trim())
            if (status) {
              if (decision) {
                status.statusRowId = '+'
                if (status.statusRow) { status.statusRow.name = 'Узгоджено' }
              } else {
                status.statusRowId = '–'
                if (status.statusRow) { status.statusRow.name = 'Відхилено' }
              }
            }
          })
          this.options.callback()
        })
      this.loading = false
    },
    canAgreeApplicationRow(decision) {
      if (!this.options.canAgree) { return false }
      let statuses = this.elements
          .map(el =>  (el.applicationRowStatuses
            .find(it => it.userId.trim() == this.options.user.id.trim())?.statusRowId )),
        result = statuses.some(el => el == '–')
        && statuses.some(el => el == '+')
      if (result) {
        return result
      }
      result = statuses.some(status => {
        return status ?  decision ? status == '+' : status == '–' : false
      })
      return !!result
    },
    callbackRject(comm) {
      this.agree(false, comm)
    },
  },
  components: {
    ChangeDate,
    CommentDialog,
    ChangeQuantity,
    InDevelopmentInfo
  }
}
</script>
